module.exports = ({
    "CDMS950TT001": "Blind",
    "CDMS950PTT001": "ประวัติการแก้ไขของ {subject_no}",
    "CDMS951P001": "กรุณากรอกเหตุผล",
    "CDMS950MSG001": "กรุณาระบุเหตุผลในการขอเปิดข้อมูลการปกปิด (Unbinding)",
    "CDMS950MSG002": "คำขอการเปิดข้อมูลการปกปิด (Unblinding) ถูกส่งแล้ว",
    "CDMS950MSG003": "กรุณาใส่รหัสความปลอดภัย",
    "CDMS950MSG004": "คำขอเปิดข้อมูลการปกปิด (Unblinding) ได้รับการอนุมัติแล้ว",
    "CDMS950MSG005": "รหัสความปลอดภัยไม่ถูกต้อง",
    "CDMS950MSG006": "คำขอเปิดข้อมูลการปกปิด (Unblinding) ถูกปฏิเสธ",
    "CDMS950MSG007": "ยกเลิกคำขอเปิดข้อมูลการปกปิด (Unblinding) เนื่องจากไม่มีผู้อนุมัติ",
    "CDMS950MSG008": "การส่งอีเมลล้มเหลว เนื่องจากไม่มีผู้ร้องขอ",
    "CDMS951BTN001": "คำขอเปิดข้อมูลฉุกเฉิน (Emergency key)",
    "CDMS952BTN001": "ยกเลิกคำขอ",
    "CDMS952BTN002": "คำขอใหม่",
    "CDMS956BTN001": "อนุมัติ",
    "CDMS956BTN002": "ปฏิเสธ",
    "CDMS951L001": "กรุณากรอกเหตุผลในการเปิดข้อมูลฉุกเฉิน (Emergency key)",
    "CDMS952L001": "คำขอเปิดข้อมูลฉุกเฉิน (Emergency key) สำหรับ [{site}][{subjectID}] กำลังอยู่ในระหว่างการรออนุมัติ หากต้องการยกเลิกหรือยื่นคำขอใหม่ กรุณากดปุ่มด้านล่าง",
    "CDMS953L001": "คุณต้องการยกเลิกคำขอเปิดข้อมูลฉุกเฉิน (Emergency key) สำหรับ [{site}][{subjectID}] ใช่หรือไม่?",
    "CDMS955L001": "กรุณากรอกรหัสความปลอดภัยเพื่อดำเนินการเปิดข้อมูล \n*กรุณาตรวจสอบรหัสความปลอดภัยทางอีเมล",
    "CDMS956L001": "กรุณาตรวจสอบเหตุผลในการเปิดข้อมูลฉุกเฉิน (Emergency key) (Emergency key) จากนั้นกรุณาเลือก “อนุมัติ” หรือ “ปฏิเสธ”",
    "CDMS957L001": "กรุณากรอกรหัสความปลอดภัยเพื่อยืนยันเปิดข้อมูลของกลุ่มผู้ปกปิดข้อมูล (Unbind) \n*กรุณาตรวจสอบรหัสความปลอดภัยทางอีเมล",
    "CDMS950L001": "Blind",
    "CDMS950L002": "รอการอนุมัติ",
    "CDMS950L003": "รอการเปิดข้อมูล",
    "CDMS950H001": "No.",
    "CDMS950H002": "ชื่อสถานวิจัย",
    "CDMS950H003": "รหัสผู้เข้าร่วมวิจัย",
    "CDMS950H004": "ปัจจัยของการแบ่งกลุ่ม (Stratification group)",
    "CDMS950H005": "IP No.",
    "CDMS950H006": "ข้อมูลกลุ่ม (ARM)",
    "CDMS950H007": "เหตุผล",
    "CDMS950H008": "Audit Trail",
    "CDMS950PH001": "No.",
    "CDMS950PH002": "ชื่อสถานวิจัย",
    "CDMS950PH003": "ปัจจัยของการแบ่งกลุ่ม (Stratification group)",
    "CDMS950PH004": "ข้อมูลกลุ่ม (ARM)",
    "CDMS950PH005": "เหตุผล",
    "CDMS950PH006": "วันที่แก้ไข",
    "CDMS950PH007": "ผู้แก้ไข",
    "CDMS955P001": "กรุณากรอกรหัสความปลอดภัย",
    "CDMS958L001": "คำขอเปิดข้อมูล [{site}][{subjectID}] ได้รับการอนุมัติแล้ว กรุณากดปุ่มเปิดด้านล่างเพื่อเปิดข้อมูลหรือยื่นคำขอใหม่",
    "CDMS958BTN002": "เปิดข้อมูล",
    "CDMS950MSG009": "รหัสความปลอดภัยไม่สามารถใช้งานได้"
});
